import Marquee from "react-fast-marquee";

const ITEMS = [
  "Returning to Love",
  "From Stress to Safety",
  "Becoming Who You Are",
  "Rooted in the Body",
  "Awakening with Care",
];

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="bg-slate border-y border-soil/10 py-6 md:py-8 overflow-hidden"
  >
    <Marquee speed={28} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-serif italic text-2xl md:text-4xl text-cream px-8 md:px-12 whitespace-nowrap">
            {item}
          </span>
          <span className="text-gold text-lg">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
